import { useDispatch, useSelector } from 'react-redux';
import { CommonDraggableTable } from '..';
import { IHomebanner, IRootState } from '../../../types/store';
import { getHomescreenBannerColumns } from './columns';
import { useMemo } from 'react';
import { showAlertDialog } from '../../../store/Reducers/AlertDialogSlice';
import { useNavigate } from 'react-router-dom';
import { EDIT_HOMESCREEN_BANNER_ROUTE } from '../../../constants/routes';
import { showNotification } from '../../../store/Reducers/NotificationSnackbarSlice';
import { HomebannerService } from '../../../api/services/homebannerService';
import { deleteBanner, setHomebanners } from '../../../store/Reducers/HomebannersSlice';
import { IHomescreenBannerDraggableTableProps } from '../../../types/commonDraggableTable';

export const HomescreenBannerDraggableTable = ({
  selectedBannerGroup,
}: IHomescreenBannerDraggableTableProps) => {
  const { banners } = useSelector((state: IRootState) => state.homebanners);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const removeHomebanner = async (banner: IHomebanner) => {
    try {
      await HomebannerService.deleteHomebanner(banner.id);
      dispatch(
        showNotification({
          message: 'Successfully deleted banner.',
        }),
      );
      dispatch(deleteBanner(banner.id));
    } catch (err: any) {
      dispatch(
        showNotification({
          message: `Failed to delete banner. ${err?.response?.data || ''}`,
          severity: 'error',
        }),
      );
    }
  };

  const onClickDelete = (banner: IHomebanner) => {
    dispatch(
      showAlertDialog({
        title: 'Delete homebanner?',
        description: 'This action cannot be undone.',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        onConfirm: () => {
          console.log('Deleting banner:', banner);
          removeHomebanner(banner);
        },
      }),
    );
  };

  const navigateToEdit = (data: IHomebanner) => {
    navigate(EDIT_HOMESCREEN_BANNER_ROUTE, {
      state: {
        banner: data,
      },
    });
  };

  const columns = useMemo(() => {
    return getHomescreenBannerColumns(onClickDelete, navigateToEdit);
  }, []);

  const onOrderChange = async (updatedRows: IHomebanner[]): Promise<void> => {
    try {
      const payload = updatedRows?.map((x: IHomebanner, index: number) => {
        return {
          id: x.id,
          sequence: index + 1,
        };
      });
      const rows = await HomebannerService.updateBannerSequence(selectedBannerGroup, payload);
      dispatch(setHomebanners(rows));
      dispatch(
        showNotification({
          message: `Successfully updated sequence of banners.`,
        }),
      );
    } catch (error: any) {
      dispatch(
        showNotification({
          message: `Failed to update sequence of banners. ${error?.response?.data || ''}`,
          severity: 'error',
        }),
      );
      throw new RangeError(`Failed to update sequence of banners. ${error?.response?.data || ''}`);
    }
  };

  return (
    <>
      <CommonDraggableTable columns={columns} data={banners} onOrderChange={onOrderChange} />
    </>
  );
};
